// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"1cbf4757","952":"a1a5f353"}[chunkId] + ".chunk.js";
};